<template>
  <div>
    <h4>英文科</h4>
    <p>
      <b>每年二月底舉辦</b>3-5年級高僑盃競試，高僑盃的成績可作為分班依據。如果沒有參加到高僑盃競試，或對高僑盃成績不滿意，約兩週後會舉辦團體甄試（請密切注意！）兩者成績擇優入班。<b>無論成績如何都至少可參加5-6年級英文文法班課程</b>。而在班就讀期間，複習考表現優良同學也可以再往上提升到更高難度的課程唷！
    </p>
    <h5>5年級</h5>
    <ul>
      <li class="check">英文文法班－上課採用多類型學習法，傳授背單字的訣竅，課程規劃奠定英文文法基礎觀念，增強文章閱讀能力，讓學生更有效率學習！
      </li>
    </ul>
    <h5>
      6年級
    </h5>
    <p>
      （教學難度由簡而深）
    </p>
    <ul>
      <li>
        英文文法班－隨著私中越來越重視英文，分數佔比也更重，高僑英文文法班更強調升私中取向的英文實力，相較於兒童美語更加強文法部份，對於升私中的訓練更扎實。
      </li>
      <br />
      <li>
        菁英英文文法班（甄試入班）－針對英文實力較強的孩子開設菁英英文文法班，課程著重文法超修、英文長篇閱讀能力，教材難易度更深、訓練更扎實。
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
